export const ADD_ACTIVITY = 'ADD_ACTIVITY';
export const DELETE_ACTIVITY = 'DELETE_ACTIVITY';
export const ADD_STUDENT_ACTIVITY = 'ADD_STUDENT_ACTIVITY';
export const DELETE_STUDENT_ACTIVITY = 'DELETE_STUDENT_ACTIVITY';
export const ADD_ACTIVITY_SEQUENCES = 'ADD_ACTIVITY_SEQUENCES';
export const ADD_STUDENT_ACTIVITY_SEQUENCES = 'ADD_STUDENT_ACTIVITY_SEQUENCES';